import { DataBean } from "../../DataBean";


export class AssetTicketCode extends DataBean {

    public async setFixedAssetTicketCodeConsecutive(consecutive: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_setFixedAssetTicketCodeConsecutive_Number", [consecutive]);
    }

}